import React, {Component} from "react";
import NumberFormat from "react-number-format";
import {LOCAL} from "../../../../constants/local";

class MoneyInput extends Component {

	static defaultProps = {
		decimalScale      : 2,
		fixedDecimalScale : true,
		decimalSeparator  : '.',
		thousandSeparator : ' ',
		suffix            : `${LOCAL.currency}`
	};

	render() {
		return (
			<NumberFormat {...this.props} />
		);
	}
}

export default MoneyInput;


// WEBPACK FOOTER //
// ./src/app/pages/User/Takemoney/Form/MoneyInput.js